import React from 'react';
import { PageWrapper } from 'components/modules/wrapper';
import Fruit from 'components/layout/Fruit/Fruit';
import { Popular } from 'components/layout/Popular';
function FruitsView() {
  return (
    <PageWrapper>
      <div className="flex flex-col lg:flex-row xl:flex-row 2xl:flex-row">
        <div className="px-4 lg:w-[70%] xl:w-[70%] 2xl:w-[70%]">
          <div className="bg-black mt-10 py-2 px-6 rounded-xl">
            <h2 className="font-semibold text-white text-base">
              All Available Fresh Fruits
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 pb-10">
            <Fruit />
          </div>
        </div>
        <div className="px-10 lg:w-[30%] xl:w-[30%] 2xl:w-[30%]">
          <div className="bg-black mt-10 py-2 px-6 rounded-xl">
            <h2 className="font-semibold text-white text-base">
              Most Purchased
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 pb-10">
            <Popular />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default FruitsView;
